import { Component, OnInit, ViewChild, Input, SimpleChanges, OnChanges, EventEmitter, Output } from '@angular/core';
import { MatSort, MatTableDataSource } from '@angular/material';
import { BaseComponent } from 'src/app/_base/base.component';
import { AttendanceRegisterStudents } from 'src/app/_models';
import { LanguageService } from 'src/app/_services';
import { Badge } from 'src/app/templates/models/badge.interface';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-register-teble',
  templateUrl: './register-teble.component.html',
  styleUrls: ['./register-teble.component.scss'],
  providers: [TranslatePipe]
})
export class RegisterTebleComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  students: AttendanceRegisterStudents[] = [];
  @Input()
  badgeStatuses: Badge[] = [];
  @Output()
  currentStatusEmitter: EventEmitter<{
    studentId: string;
    statusId: number;
  }> = new EventEmitter<{
    studentId: string;
    statusId: number;
  }>();
  dataToBindSource = new MatTableDataSource<AttendanceRegisterStudents>();
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['i', 'name', 'schoolStatusId', 'statusId', 'comment', 'totalAbsent'];
  constructor(private languageService: LanguageService, private translatePipe: TranslatePipe) {
    super();
    this.tableColumnInit();
  }

  ngOnInit() {
    this.tableColumnInit();
  }
  tableColumnInit(): void {
    !this.settings.rtl ? (this.displayedColumns[1] = 'nameEn') : (this.displayedColumns[1] = 'name');
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.students) {
      this.tableInit();
    }
  }
  tableInit(): void {
    this.dataToBindSource.data = this.students;
    setTimeout(() => {
      this.dataToBindSource.sort = this.sort;
    }, 50);
  }
  statusIdChanged(studentId: string, statusId: number): void {
    this.currentStatusEmitter.emit({
      studentId,
      statusId
    });
  }
  getSchoolStatus(schoolStatusId: number): string {
    const status: Badge = this.badgeStatuses.find(item => item.id === schoolStatusId);
    return schoolStatusId
      ? !this.settings.rtl
        ? status.nameEn
        : status.name
      : this.translatePipe.transform('AcademicModule.notesModule.NotTaken');
  }
}
